import React, { Fragment } from 'react';
import { CheckIcon } from 'lucide-react';
interface FormStepperProps {
  currentStep: number;
  steps: string[];
}
export function FormStepper({
  currentStep,
  steps
}: FormStepperProps) {
  return <div className="mb-12" data-id="element-363">
      <div className="flex items-center justify-between" data-id="element-364">
        {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isCurrent = stepNumber === currentStep;
        return <Fragment key={index} data-id="element-365">
              <div className="flex flex-col items-center flex-1" data-id="element-366">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold mb-2 transition-all ${isCompleted ? 'bg-au-green text-white' : isCurrent ? 'bg-au-green text-white ring-4 ring-au-green-light' : 'bg-gray-200 text-gray-500'}`} data-id="element-367">
                  {isCompleted ? <CheckIcon size={24} data-id="element-368" /> : stepNumber}
                </div>
                <span className={`text-sm font-medium text-center ${isCurrent ? 'text-au-green' : 'text-gray-600'}`} data-id="element-369">
                  {step}
                </span>
              </div>
              {index < steps.length - 1 && <div className={`h-1 flex-1 mx-2 mb-8 transition-all ${isCompleted ? 'bg-au-green' : 'bg-gray-200'}`} data-id="element-370"></div>}
            </Fragment>;
      })}
      </div>
    </div>;
}